var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNotificationGuesty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_1_",
    d: "M20,0C8.9542847,0,0,8.9542847,0,20s8.9542847,20,20,20s20-8.9542847,20-20S31.0457153,0,20,0z  M28.9805298,26.2817993C28.9805298,26.6787109,28.6590576,27,28.2619629,27s-0.7185059-0.3212891-0.7185059-0.7182007V16.548645 l-7.0623779-4.9516602l-7.0623169,4.9516602v9.0150146h10.1444092v-6.9927979l-3.0726318-2.154541l-3.0726318,2.154541v3.7232056 c0,0.3968506-0.3214722,0.7181396-0.7185059,0.7181396c-0.3970947,0-0.7185669-0.3212891-0.7185669-0.7181396V18.211792 c-0.0094604-0.2268066,0.0945435-0.4630737,0.3025513-0.6047974l3.7060547-2.5986328 c0.1229248-0.085083,0.2930908-0.1795654,0.4633179-0.1890259h0.0756226c0.170166,0,0.3308716,0.0944824,0.4632568,0.1890259 l3.7155151,2.5891724c0.2174683,0.1606445,0.3025513,0.3212891,0.3025513,0.6142578v8.0700073 C25.0097046,26.6787109,24.6882324,27,24.2911987,27H12.7191162c-0.3970947,0-0.7185059-0.3212891-0.7185059-0.7182007V16.1989746 c-0.0094604-0.2362061,0.0945435-0.4724731,0.3024902-0.6141968l7.6958008-5.395813 C20.1407471,10.085022,20.2919922,10.0094604,20.4621582,10h0.0756836c0.170166,0,0.3214111,0.085022,0.4632568,0.1889648 l7.6958008,5.395813c0.2079468,0.1417236,0.3119507,0.3779907,0.2836304,0.6331177V26.2817993z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotificationGuesty);
export default __webpack_public_path__ + "static/media/IcoNotificationGuesty.da075fd91d70053605a49a1ddac00e6c.svg";
export { ForwardRef as ReactComponent };